<template>
    <div class="layout__position-left layout__width-100">

        <el-form :model="searchParams" status-icon :rules="rules" ref="searchParams">

            <div class="layout__padding-clear text__align-center layout__width-100">
                <div class="layout__search-field__insights-120px">
                    <p class="layout__margin__bottom-10 text__align-left">Month / Year</p>
                    <el-form-item prop="salesMonthYear">
                        <el-date-picker
                                v-model="searchParams.salesMonthYear" 
                                type="month"
                                placeholder="Pick a month"
                                :picker-options="pickerOptions"
                                format="MM/yyyy"
                                value-format="MM/yyyy">
                        </el-date-picker>
                    </el-form-item>
                </div>
                <div class="layout__search-field__admin">
                    <p class="layout__margin__bottom-10 text__align-left">Territory</p>
                    <el-form ref="customer">
                        <el-form-item prop="search">
                            <el-select v-model="searchParams.territory" placeholder="Territory" clearable @change="handleTerritorySelect">
                                <el-option v-for="territory in territories"
                                           :key="territory.territory"
                                           :label="territory.territory"
                                           :value="territory.territory">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </div>
            </div>

        </el-form>

        <el-button class="button-red button__base button__insights" v-on:click="getSales('searchParams')">Refresh Data
        </el-button>

        <el-button class="button-teal button__base button__insights" :disabled="this.sales.length === 0" v-on:click="csv()">Download CSV
        </el-button>

    </div>

</template>

<script>

    import Axios from 'axios';
    import moment from 'moment';
    import {axios} from '@/mixins/Axios.js';
    import {csvDownloadHelper} from '@/mixins/CsvDownloadHelper.js';
    import {dataFormatter} from '@/mixins/DataFormatter.js';

    export default {
        name: "lapsedCustomersSearch",
        mixins: [axios, csvDownloadHelper, dataFormatter],
        props: {
            searchParams: {},
            sales: []
        },
        data() {
            return {
                serviceRouteUrl: `${process.env.VUE_APP_INSIGHTSAPIHOST}`,
                exportDate: new Date().toLocaleDateString('en-GB') + '_sales.csv',
                territories: [],
                downloadUrl: '',
                myChart: Object,
                pickerOptions: {
                    shortcuts: [{
                        text: 'This month',
                        onClick(picker) {
                            const start = new Date();
                            start.setTime(start.getTime());
                            picker.$emit('pick', start);
                        }
                    }]
                }
            }
        },
        computed: {
          toDate() {
              return this.searchParams.salesToDate;
          }
        },
        created() {
            console.log('CREATED')
            const date = new Date();
            date.setDate(date.getDate() - 7)
            console.log('created date')

            this.searchParams.salesMonthYear = moment().format('MM/YYYY');
            this.searchParams.territory = '';

            console.log(this.searchParams)
        },
        mounted() {
            console.log('MOUNTED');
            this.getSales('searchParams');
        },
        destroyed() {
            console.log('DESTROYED')
            this.searchParams.salesMonthYear = moment().format('MM/YYYY');
            this.searchParams.territory = '';

            console.log(this.searchParams)
        },
        beforeUpdate() {
            window.sessionStorage.setItem('_search', JSON.stringify(this.searchParams));
        },
        methods: {
            getSales(searchParams) {

                this.$refs[searchParams].validate((valid) => {
                    if (valid) {

                        console.log('before')
                        console.log(this.searchParams)

                        let searchTerms = Object.assign({}, this.searchParams)
                        console.log('searchTerms')
                        console.log(searchTerms)

                        console.log('after search is copied')
                        console.log(this.searchParams)

                        console.log('after search is copied - new object')
                        console.log(searchTerms)

                        var monthYearArray = searchTerms.salesMonthYear.split("/"),
                            monthYear = moment(new Date(monthYearArray[1], monthYearArray[0] - 1, 1)).format('YYYY%2FMM%2FDD'),
                            endpoint = this.serviceRouteUrl + '/api/v1/insights/order/GetLapsedCustomers?startDate=' + monthYear + '&endDate=' + monthYear;

                        console.log(endpoint)

                        this.$parent.loading = true;

                        Axios.get(endpoint, this.returnHeaderUsingToken())
                        .then(response => {
                            var lookup = {},
                                result = [],
                                custNo = 0,
                                orderDate,
                                orders;

                            if (searchTerms.territory == '') {
                                orders = response.data.lapsedCustomers;
                            } else {
                                var filtered = response.data.lapsedCustomers.filter(function(item){
                                    return item.territory == searchTerms.territory;
                                });
                                orders = filtered;
                            }

                            this.$parent.sales = orders;

                            if (this.territories.length === 0) {
                                var lookup = {};
                                var orders = this.$parent.sales;
                                for (var order, i = 0; order = orders[i++];) {
                                    var territory = order.territory;
                                    if (territory !== "" && territory !== null) {
                                        if (!(territory in lookup)) {
                                            lookup[territory] = 1;
                                            this.territories.push({territory: territory});
                                        }
                                    }
                                }
                                this.territories.sort((a, b)=> {
                                    var a1 = a.territory.toLowerCase();
                                    var b1 = b.territory.toLowerCase();
                                    return a1<b1 ?-1:a1> b1? 1 :0;
                                })
                            }

                            this.$nextTick(() => { // Loading should be closed asynchronously
                                this.$parent.loading = false;
                            });
                        })
                        .catch(error => {
                            if (error.response) {
                                this.$message.error('Sorry there has been an issue retrieving the information you requested.');
                            }

                            this.$nextTick(() => { // Loading should be closed asynchronously
                                this.$parent.loading = false;
                            });

                            this.$parent.sales = [];
                        })
                    } else {
                        return false;
                    }
                })
            },
            handleTerritorySelect(val) {
                console.log('handleTerritorySelect');

                if (val == null) {
                    val = '';
                }

                console.log(val);
                this.searchParams.territory = val;
                this.getSales('searchParams');
            },
            csv() {
                const fields = [
                    {label: 'Territory', value: 'territory'},
                    {label: 'Branch', value: 'branch'},
                    {label: 'Brand', value: 'brand'},
                    {label: 'Client Name', value: 'clientName'},
                    {label: 'Branch Name', value: 'branchName'},
                    {label: 'Address', value: 'address'},
                    {label: 'Client Tel', value: 'clientTelephone'},
                    {label: 'Client Email', value: 'clientEmail'},
                    {label: 'Status', value: 'status'},
                    {label: 'Last Order Date', value: (row, field) => row.lastOrderDate.replace('T', ' ').replace(/\.[0-9]{3}/, '').replace(/\.[0-9]{2}/, '').replace(/\.[0-9]{1}/, '')},
                    {label: 'Total Six Month Spend', value: 'totalSixMonthSpend'}
                ];

                this.downloadCsv(this.exportDate, fields, this.sales)
            }
        }
    };
</script>